/**
 * Single source of truth for the enrollment flow's light-green accent.
 *
 * The configure modal + results drawer are visual clones of the talent-search
 * export wizard, swapping export's gold (`#FFAF53`) for this green. Black text
 * sits on the green fill exactly like export's primary CTA. The exact hexes are
 * an intentional brand accent (mirrors export's hardcoded gold) and are kept
 * here so no component hand-rolls them.
 */

export const ENROLLMENT_ACCENT = {
  base: "#87FFA5",
  hover: "#6FE88D",
  active: "#5CD97B",
  border: "#5FBF77",
  /** Darker green for accent text/icons on light backgrounds (the bright
   * `base` green is illegible on white, so light mode uses this instead). */
  textOnLight: "#2f8f4f",
} as const;

/** Primary CTA classes (clone of export's SubmitButton, gold → green, black text). */
export const ENROLLMENT_PRIMARY_BTN =
  "bg-[#87FFA5] border-[#5FBF77] text-black hover:bg-[#6FE88D] active:bg-[#5CD97B]";

/** Stepper active circle (clone of export's `bg-[#FFAF53] text-black`). */
export const ENROLLMENT_STEP_ACTIVE = "bg-[#87FFA5] text-black";

/** Accent text/icon color: darker green on light, bright green on dark. */
export const ENROLLMENT_ACCENT_TEXT = "text-[#2f8f4f] dark:text-[#87FFA5]";
